import * as React from "react";

import { useWarmUpQaWorkersMutation } from "../chat.api";

/**
 * Fire-and-forget wake-up of the scale-to-zero interactive-query workers.
 *
 * Mount this on every entry point into the Q&A area (recent-QA list, empty chat
 * page) so the workers boot while the user is still picking a conversation or
 * typing — before the chat WebSocket (which also warms) even connects. The
 * backend debounces namespace-wide, so mounting it in several views is free.
 */
export const useQaWorkerWarmup = (): void => {
  const [warmUp] = useWarmUpQaWorkersMutation();

  React.useEffect(() => {
    warmUp().catch(() => {
      // Purely an optimization: a failed warm-up must never surface to the user.
    });
  }, [warmUp]);
};
